// extracted by mini-css-extract-plugin
export default {"Plans":"Plans_Plans__rSYDU","Container__Filter":"Plans_Container__Filter__ELZjL","Container__Boxes":"Plans_Container__Boxes__vzXvv"};